import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { ocActivePageSideMenuState } from "oc/states";

interface UseOcPageSideMenuProps {
  id: string;
  initialValue: any;
}

export const useOcPageSideMenu = ({
  id,
  initialValue,
}: UseOcPageSideMenuProps) => {
  const state = useRecoilValue(ocActivePageSideMenuState(id));
  const setState = useSetRecoilState(ocActivePageSideMenuState(id));
  const resetState = useResetRecoilState(ocActivePageSideMenuState(id));

  return {
    state: state || initialValue,
    setState,
    resetState,
  };
};

export default useOcPageSideMenu;
